import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";
import { Skeleton } from "@/components/ui/skeleton";
import { ArrowRight, Calendar } from "lucide-react";

export default function Blog() {
  const [blogs, setBlogs] = useState(null);
  useEffect(() => { api.get("/blogs").then((r) => setBlogs(r.data)).catch(() => setBlogs([])); }, []);
  return (
    <div>
      <SEO title="Real Estate Blog | Bangalore Property Guides | Mathura Homes" description="Expert guides on buying property in Bangalore — best areas, RERA, documentation, investment tips and more." />
      <section className="bg-navy py-20 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <span className="inline-block h-1 w-16 bg-gold mb-6" />
          <h1 className="font-display text-4xl md:text-5xl text-white">Insights & Guides</h1>
          <p className="text-gray-300 mt-5">Practical advice to help you buy property in Bangalore with confidence.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {blogs === null ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-80 rounded-2xl" />)}</div>
        ) : blogs.length === 0 ? (
          <p className="text-center text-muted-foreground py-12">No articles yet. Check back soon.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blogs.map((b) => (
              <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all flex flex-col">
                <div className="aspect-[16/10] overflow-hidden"><img src={b.cover_image} alt={b.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
                <div className="p-6 flex flex-col flex-1">
                  <span className="text-xs text-gold-dark font-semibold uppercase tracking-wider">{b.category || "Guide"}</span>
                  <h2 className="font-display text-xl text-navy mt-2 leading-tight group-hover:text-gold-dark transition-colors">{b.title}</h2>
                  <p className="text-sm text-muted-foreground mt-2 line-clamp-2 flex-1">{b.excerpt}</p>
                  <span className="text-sm text-gold font-semibold mt-4 inline-flex items-center gap-1">Read More <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
